module.exports = __webpack_public_path__ + "img/law1m-m@1.030d93a0.webp";